import {getState} from '../slices/uamData';

const selectUamData = () => getState();

const selectUamApiKey = () => selectUamData().apiKey;
const selectUamApiUrl = () => selectUamData().apiUrl;
const selectUamAuthHolderToken = () => selectUamData().authHolderToken;
const selectUamAuthToken = () => selectUamData().authToken;
const selectUamAssetId = (isHolder) => {
    const assets = selectUamData().assets;

    //!! used to resolve undefined, null and false as same
    return assets.find((x) => !!x.isHolder === !!isHolder)?.assetId;
};
const selectIsHolderAssetId = (assetId) => {
    const assets = selectUamData().assets;

    return assets.find((x) => x.assetId === assetId)?.isHolder;
};

export {
    selectUamApiKey,
    selectUamApiUrl,
    selectUamAuthHolderToken,
    selectUamAuthToken,
    selectUamAssetId,
    selectIsHolderAssetId,
};
